import { useLazyGetOpenQuizzesQuery } from '../slices/fun_stuff/quizSlice';
import { useDispatch } from 'react-redux';
import { setQuizList } from '../slices/fun_stuff/quizAuthSlice';

export const useLoadQuizList = () => {
  const dispatch = useDispatch();
  const [getQuizzes, { isLoading, error }] = useLazyGetOpenQuizzesQuery();

  const loadQuizzes = async () => {
    const data = await getQuizzes().unwrap();
    dispatch(setQuizList(data));
    return;
  };

  return { loadQuizzes, isLoading, error };
};
